module.exports = __webpack_public_path__ + "img/consulting.b0f1ea55.png";